module.exports = __webpack_public_path__ + "static/media/navaneeth_profile.ff50ed3d.png";